/*
 * @Descripttion: 可开票订单页state
 * @Author: 曹博
 * @Date: 2023-12-04 10:11:09
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-04 10:11:15
 */
import { ActionType, CustomAction } from '../../global'

interface PaginationOption {
  pageNo: number
  pageSize: number
}

export interface State {
  dataSource: { data: any[]; total: number }
  isTableLoading: boolean
  paginationOption: PaginationOption
  searchParam: any
  selectedRows: any[]
}

export const initialState: State = {
  dataSource: { data: [], total: 100 },
  isTableLoading: false,
  paginationOption: {
    pageNo: 1,
    pageSize: 20,
  },
  searchParam: {},
  selectedRows: [],
}

type Action = ActionType<State>

export default function reducer(
  state: State,
  action: CustomAction<Action>,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setPaginationOptionAction':
      newstate.paginationOption = action.payload
      return newstate
    case 'setDataSourceAction':
      newstate.dataSource = action.payload.dataSource
      newstate.paginationOption.pageNo = action.payload.pageNo
      return newstate
    case 'setIsTableLoadingAction':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setSearchParamAction':
      newstate.searchParam = action.payload
      newstate.paginationOption.pageNo = 1
      return newstate
    case 'setSelectedRowsAction':
      newstate.selectedRows = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

/**
 * 设置分页相关选项
 * @param param
 * @returns
 */
export const setPaginationOptionAction = (val: {
  pageNo: number
  pageSize?: number
}): CustomAction<Action> => ({
  type: 'setPaginationOptionAction',
  payload: val,
})

/**
 *设置当前表格数据
 * @param val
 * @returns
 */
export const setDataSourceAction = (val: {
  dataSource: { data: any[]; total: number }
  pageNo: number
}): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: val,
})

/**
 * 设置表格加载
 * @param val
 * @returns
 */
export const setIsTableLoadingAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsTableLoadingAction',
  payload: val,
})

/**
 * @param val
 * @returns
 */
export const setSelectedRowsAction = (val: any): CustomAction<Action> => ({
  type: 'setSelectedRowsAction',
  payload: val,
})

// 搜索参数
export const setSearchParamAction = (param: any): CustomAction<Action> => ({
  type: 'setSearchParamAction',
  payload: param,
})
/*
 * @Descripttion: 可开票订单页state
 * @Author: 曹博
 * @Date: 2023-12-04 10:11:09
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-04 10:11:15
 */
import { ActionType, CustomAction } from '../../global'

interface PaginationOption {
  pageNo: number
  pageSize: number
}

export interface State {
  dataSource: { data: any[]; total: number }
  isTableLoading: boolean
  paginationOption: PaginationOption
  searchParam: any
  selectedRows: any[]
}

export const initialState: State = {
  dataSource: { data: [], total: 100 },
  isTableLoading: false,
  paginationOption: {
    pageNo: 1,
    pageSize: 20,
  },
  searchParam: {},
  selectedRows: [],
}

type Action = ActionType<State>

export default function reducer(
  state: State,
  action: CustomAction<Action>,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setPaginationOptionAction':
      newstate.paginationOption = action.payload
      return newstate
    case 'setDataSourceAction':
      newstate.dataSource = action.payload.dataSource
      newstate.paginationOption.pageNo = action.payload.pageNo
      return newstate
    case 'setIsTableLoadingAction':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setSearchParamAction':
      newstate.searchParam = action.payload
      newstate.paginationOption.pageNo = 1
      return newstate
    case 'setSelectedRowsAction':
      newstate.selectedRows = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

/**
 * 设置分页相关选项
 * @param param
 * @returns
 */
export const setPaginationOptionAction = (val: {
  pageNo: number
  pageSize?: number
}): CustomAction<Action> => ({
  type: 'setPaginationOptionAction',
  payload: val,
})

/**
 *设置当前表格数据
 * @param val
 * @returns
 */
export const setDataSourceAction = (val: {
  dataSource: { data: any[]; total: number }
  pageNo: number
}): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: val,
})

/**
 * 设置表格加载
 * @param val
 * @returns
 */
export const setIsTableLoadingAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsTableLoadingAction',
  payload: val,
})

/**
 * @param val
 * @returns
 */
export const setSelectedRowsAction = (val: any): CustomAction<Action> => ({
  type: 'setSelectedRowsAction',
  payload: val,
})

// 搜索参数
export const setSearchParamAction = (param: any): CustomAction<Action> => ({
  type: 'setSearchParamAction',
  payload: param,
})
